import { ICourseCatalogLandingPageQuery } from '../interfaces/course-catalog-landing-page.query.interface';
import { MaxbrainImage } from 'app/library/image-library/models/maxbrain-image.model';
import { PostingType } from 'app/library/posting/models/posting-type.model';
import { SimpleEntity } from 'app/projects/shared/src/lib/models/simple-entity.model';

// @dynamic
export class CourseCatalogLandingPage {
    id: string;
    categoryId: number;
    status: string;
    title: string;
    language: string;
    description: string;
    shortDescription: string;
    image: MaxbrainImage;
    postingType: PostingType;
    experiences: SimpleEntity[];

    constructor(query: ICourseCatalogLandingPageQuery) {
        this.id = query.id.toString();
        this.categoryId = query.category.id;
        this.status = query.status;
        this.title = query.title;
        this.language = query.language;
        this.description = query.description;
        this.shortDescription = query.short_description;
        this.image = query.image ? new MaxbrainImage(query.image) : null;
        this.postingType = new PostingType(query.posting_type);
        this.experiences = query.experiences.map((experience) => new SimpleEntity(experience));
    }
}
